import React from 'react';
import { Icon } from 'semantic-ui-react';
// Reusable status badge component
export const StatusBadge = ({ label, iconName, bgColor, textColor }) => (React.createElement("span", { className: `inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${bgColor} ${textColor}` },
    React.createElement(Icon, { name: iconName, style: { width: '12px', marginRight: '4px' } }),
    label));
// Status badge renderer using FormStages
export const renderStatusBadge = (status) => {
    switch (status) {
        case 'draft':
            return (React.createElement(StatusBadge, { label: "Draft", iconName: "clock", bgColor: "bg-gray-100", textColor: "text-gray-800" }));
        case 'review':
            return (React.createElement(StatusBadge, { label: "Review", iconName: "warning circle", bgColor: "bg-yellow-100", textColor: "text-yellow-800" }));
        case 'finalized':
            return (React.createElement(StatusBadge, { label: "Finalized", iconName: "check circle", bgColor: "bg-green-100", textColor: "text-green-800" }));
        default:
            return (React.createElement(StatusBadge, { label: status, iconName: "question circle", bgColor: "bg-gray-100", textColor: "text-gray-800" }));
    }
};
